import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { DistributorPrice } from 'types/api/distributor.type';

import { distributorDataService } from 'services/distributor.service';

import { LayoutContext } from 'contexts';

import { useFetch } from 'hooks';

import { checkParams } from 'helpers/checkParams';

const useList = () => {
  const { control, watch } = useForm();

  const [products, productsSet] = useState<DistributorPrice[]>();

  const { breadcrumbSet, breadcrumbSecondarySet } = useContext(LayoutContext);

  const { season, marketLine, zone, genderCode, category } = watch();

  const params = {
    season,
    marketLine,
    genderCode,
    zone,
    category,
  };

  const { content, isLoading } = useFetch(
    checkParams(params) ? () => distributorDataService.getPrices(params) : undefined,
    [season, marketLine, zone, genderCode, category]
  );

  useEffect(() => {
    if (content) {
      productsSet(content);
    }
  }, [content]);

  useEffect(() => {
    const breadcrumb = [
      {
        label: 'prices',
      },
    ];

    breadcrumbSet(breadcrumb);

    const breadcrumbSecondary = [
      {
        label: 'settings',
      },
      {
        label: 'prices',
      },
    ];

    breadcrumbSecondarySet(breadcrumbSecondary);
  }, []);

  return {
    products,
    control,
    watch,
    season,
    zone,
    isLoading,
  };
};

export { useList };
